import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from "@material-ui/core";
import { useState } from "react";
import { useBetween } from "use-between";
const WholesaleOverviewCheckbox = (props) => {
    const { checkedSet, addApp, removeApp } = SharedCheckedSet();
    const { DaysUntilEndDateStatus, Status } = props;
    return (_jsx(Checkbox, { checked: checkedSet.has(props.ApplicationNumber), disabled: DaysUntilEndDateStatus === "black" || Status !== 5, onChange: (_, checkedValue) => {
            checkedValue
                ? addApp(props.ApplicationNumber)
                : removeApp(props.ApplicationNumber);
        } }));
};
const WholesaleCheckedSet = () => {
    const [checkedSet, setCheckedSet] = useState(new Set());
    //Creates new Set instances, so that react re-renders checkboxes
    const addApp = (app) => {
        setCheckedSet(_ => new Set([...checkedSet, app]));
    };
    const removeApp = (app) => {
        setCheckedSet(_ => new Set([...checkedSet].filter(x => x !== app)));
    };
    const removeAllChecked = () => {
        setCheckedSet(_ => new Set());
    };
    return { checkedSet, addApp, removeApp, removeAllChecked };
};
const SharedCheckedSet = () => useBetween(WholesaleCheckedSet);
export { WholesaleOverviewCheckbox, SharedCheckedSet };
//# sourceMappingURL=WholesaleOverviewCheckbox.js.map